if (typeof Promise === 'undefined') {
    if (process.env.NODE_ENV === 'development')
        require('promise/lib/rejection-tracking').enable();
    window.Promise = require('promise/lib/es6-extensions');
}

Object.assign = require('object-assign');


if (!window.crypto)
    window.crypto = window.msCrypto;

require('core-js/features/object/keys');
require('core-js/features/symbol');
require('core-js/features/array/from');
require('core-js/features/array/find');
require('core-js/features/array/includes');
require('core-js/features/array/find-index');
require('core-js/features/string/includes');
require('core-js/features/string/pad-start');
require('core-js/features/string/repeat');
require('core-js/features/number/is-nan');
require('core-js/features/number/is-integer');
require('core-js/features/number/is-finite');
require('core-js/es/typed-array');

// landing-only?
require('core-js/features/object/values');
require('core-js/features/object/entries');
require('core-js/features/array/fill');
require('core-js/features/set');
require('core-js/features/string/starts-with');

require('css-vars-ponyfill').default({ onlyVars: true });
